export default "assets/images/icons/mail-aca72ba4.svg";